import { render, staticRenderFns } from "./RestaurantAreaDeliveryFee.vue?vue&type=template&id=17737cd1&scoped=true&"
import script from "./RestaurantAreaDeliveryFee.vue?vue&type=script&lang=js&"
export * from "./RestaurantAreaDeliveryFee.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantAreaDeliveryFee.vue?vue&type=style&index=0&id=17737cd1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17737cd1",
  null
  
)

export default component.exports